<div class="is-loading icon-and-text title is-level-5 {{ isMobile && 'is-stacked' }} icon-and-text is-fullwidth">
    <div class="columns is-aligned-center is-mobile is-vertical-mobile">
        <div class="column has-text-centered-mobile">
            <span class="has-text-centered has-text-weight-semibold">
                Ajoutez {{ isMobile ? 'une Bbox' : 'un forfait' }} pour faire des B.iG économies&nbsp;!
            </span>
            <span class="text is-level-1 is-marginless has-text-weight-normal is-block">
                Avec une Bbox et un forfait, vous économisez sur vos offres internet et mobile.
            </span>
        </div>
    </div>
</div>
